import { createAction } from "redux-actions";
import types from "./types";

export const getStaticData = createAction(types.GET_STATIC_DATA);
export const getStaticDataSuccess = createAction(types.GET_STATIC_DATA_SUCCESS);



// WEBPACK FOOTER //
// ./src/infraMonitor/staticData/actions.js